<template>
    <div class="d-flex">
        <div>{{ checkOut }}</div>
        <div v-if="arrival.is_late_check_out" class="check-out-icon">
            <img src="/static/images/reservations/late-check-out.svg" title="Late Check-out" />
        </div>
    </div>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

export default {
    name: 'CheckOutCellRenderer',
    computed: {
        checkOut() {
            if (this.arrival) {
                return format(parseISO(this.arrival.to_date + ' ' + this.arrival.check_out), 'hh:mm a')
            }
        }
    },
    data() {
        return {
            arrival: null,
        };
    },
    created() {
        this.arrival = this.params.data;
    },
};
</script>

<style lang="scss" scoped>
    .check-out-icon {
        margin-left: .5rem;
        img {
            width: 20px;
            height: 20px;
        }
    }
</style>
